import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ChunkLoadRecoveryModalProps {
  open: boolean;
  onReload: () => void;
}

export function ChunkLoadRecoveryModal({
  open,
  onReload,
}: ChunkLoadRecoveryModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Refresh Required</AlertDialogTitle>
          <AlertDialogDescription>
            Part of Sked failed to load. Refresh to pick up the latest app files
            and continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onReload}>Refresh Page</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
